<template>
  <div class="panel-qr-card mb-5">
    <div class="qr-layout">
      <div ref="frame" class="qr-frame" aria-hidden="true"></div>

      <div class="qr-text">
        <h4 class="title">ورود به پنل</h4>
        <p class="description">
          کارمندان می‌توانند این کد را اسکن کنند و با شماره همراه خود وارد پنل
          شوند.
        </p>

        <div class="qr-actions">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-message-square"
            @click="$emit('sendLink')"
          >
            ارسال لینک
          </vs-button>

          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-download"
            @click="download()"
          >
            دانلود QR
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { PANEL_URL } from "../../helpers/Constants";
  import { createQrInstance, generateQr } from "../../utilities/qr/generate-qr";

  const DISPLAY_SIZE = 160;

  const QR_SOURCE_SIZE = 1000;

  export default {
    name: "PanelQrCard",

    data() {
      return {
        panelUrl: PANEL_URL,
      };
    },

    methods: {
      download() {
        generateQr(this.panelUrl, "panel", "png");
      },
    },

    mounted() {
      const frame = this.$refs.frame;
      if (!frame) return;

      createQrInstance(this.panelUrl).append(frame);

      const code = frame.firstElementChild;
      if (!code) return;

      code.setAttribute("viewBox", `0 0 ${QR_SOURCE_SIZE} ${QR_SOURCE_SIZE}`);
      code.setAttribute("width", DISPLAY_SIZE);
      code.setAttribute("height", DISPLAY_SIZE);
      code.style.display = "block";
    },
  };
</script>

<style scoped lang="scss">
  .panel-qr-card {
    padding: 16px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);

    .qr-layout {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .qr-frame {
      width: 160px;
      height: 160px;
      flex-shrink: 0;
      border-radius: 8px;
      overflow: hidden;
    }

    .qr-text {
      min-width: 0;
    }

    .title {
      margin-bottom: 4px;
      font-weight: 600;
    }

    .description {
      font-size: 13px;
      opacity: 0.75;
    }

    .qr-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 16px;
    }

    @media (max-width: 576px) {
      .qr-layout {
        flex-direction: column;
        align-items: stretch;
        text-align: center;
      }

      .qr-frame {
        align-self: center;
      }

      .qr-actions {
        justify-content: center;
      }
    }
  }
</style>
